import { useHistory } from 'react-router-dom'
import NotificationMenu from '../../../../../components/stories/organisms/top-navigation/components/notification-menu'
import { useNotificationsGetAllQuery } from '../../../../../react-query/notifications/query/use-notifications-get-all-query'
import { useNotificationsUnreadQuery } from '../../../../../react-query/notifications/query/use-notifications-unread-query'
import { useNotificationsReadAllMutation } from '../../../../../react-query/notifications/mutation/use-notifications-read-all-mutation'
import { useGetEmailFrequencyQuery } from '../../../../../react-query/notifications/query/use-get-email-frequency-query'
import { useUpdateEmailFrequencyMutation } from '../../../../../react-query/notifications/mutation/use-update-email-frequency-mutation'
import { getEmailFrequencyObject } from './constants'
import { useGetSubscriptionsQuery } from '../../../../../react-query/subscription/query/use-get-subscriptions-query'

const NOTIFICATIONS_POLLING_INTERVAL_MS = 45 * 1000

const Notifications = () => {
  const { push } = useHistory()

  const { data: emailFrequencyData } = useGetEmailFrequencyQuery()
  const { mutate } = useNotificationsReadAllMutation()
  const { mutate: mutateEmailFrequency } = useUpdateEmailFrequencyMutation()

  // init subscriptions
  useGetSubscriptionsQuery()

  const { data: hasUnreadNotifications } = useNotificationsUnreadQuery()

  const { data, isPending, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useNotificationsGetAllQuery(15, {
      refetchInterval: NOTIFICATIONS_POLLING_INTERVAL_MS,
      refetchIntervalInBackground: false
    })

  const etag = data?.pages?.[0]?.etag ?? null

  const allNotifications =
    data?.pages?.flatMap((page) => page?.items ?? []) || []

  const onBottomReached = () => {
    hasNextPage && !isFetchingNextPage && fetchNextPage()
  }

  const handleNavigateToNotifications = (url) => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      window.location.href = url
    } else {
      push(url)
    }
  }

  const handleOnCloseCallback = () => {
    mutate({ timestamp: etag ?? new Date().toISOString() })
  }

  const handleChangeEmailFrequency = (selectedItem) => {
    mutateEmailFrequency({ emailFrequency: selectedItem['data-api'] })
  }

  const emailFrequency = getEmailFrequencyObject(
    emailFrequencyData?.emailFrequency
  )

  return (
    <NotificationMenu
      isLoading={isPending}
      key="notification"
      notificationData={allNotifications}
      onClickNotification={(item) =>
        handleNavigateToNotifications(item?.links[0]?.href ?? '#')
      }
      handleSelectEmailNotification={(selectedItem) => {
        handleChangeEmailFrequency(selectedItem)
      }}
      defaultSelectedValue={[emailFrequency]}
      onBottomReached={onBottomReached}
      hasUnreadNotifications={hasUnreadNotifications?.check}
      isFetchingNextPage={isFetchingNextPage}
      onCloseCallback={handleOnCloseCallback}
    />
  )
}

export default Notifications
